import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "nav-bar"
}
const _hoisted_4 = { class: "nav-content" }
const _hoisted_5 = {
  key: 0,
  class: "playlist-dropdown"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "song-name"
}
const _hoisted_8 = { class: "time-board" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "date" }
const _hoisted_11 = {
  key: 2,
  class: "user-info-mobile"
}
const _hoisted_12 = { class: "user-row" }
const _hoisted_13 = {
  key: 2,
  class: "user-info-fixed"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ScrollToTop = _resolveComponent("ScrollToTop")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("audio", {
      ref: "bgMusic",
      onEnded: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.playNextSong && _ctx.playNextSong(...args)))
    }, [
      _createElementVNode("source", {
        src: _ctx.currentSong,
        type: "audio/mp3"
      }, null, 8, _hoisted_2)
    ], 544),
    (
         _ctx.$route.path !== '/game'
         && _ctx.$route.path !== '/view'
      )
      ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "music-control",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMusic && _ctx.toggleMusic(...args))),
              title: "点击播放/暂停背景音乐"
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["music-icon", { 'playing': _ctx.isPlaying }])
              }, "🎵", 2)
            ]),
            _createElementVNode("div", {
              class: "music-control next-song",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePlaylist && _ctx.togglePlaylist(...args))),
              title: "选择歌曲"
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("span", { class: "music-icon" }, [
                _createElementVNode("i", { class: "fas fa-list" })
              ], -1)
            ])),
            (_ctx.showPlaylist)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.songNames, (song, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["playlist-item", { 'active': index === _ctx.currentSongIndex }]),
                      key: index,
                      onClick: ($event: any) => (_ctx.selectSong(index))
                    }, _toDisplayString(song), 11, _hoisted_6))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.isPlaying)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("span", null, "正在播放：" + _toDisplayString(_ctx.currentSongName), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.currentTime), 1),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.currentDate), 1)
            ]),
            _createElementVNode("div", {
              class: "menu-icon",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["fas", _ctx.isMenuOpen ? 'fa-close' : 'fa-bars'])
              }, null, 2)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["nav-links", { 'nav-active': _ctx.isMenuOpen }])
            }, [
              _createVNode(_component_router_link, {
                to: "/home",
                class: "nav-link",
                "active-class": "active",
                onClick: _ctx.closeMenu
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("首页")
                ])),
                _: 1,
                __: [10]
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                to: "/about",
                class: "nav-link",
                "active-class": "active",
                onClick: _ctx.closeMenu
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("关于万绿")
                ])),
                _: 1,
                __: [11]
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                to: "/gallery",
                class: "nav-link",
                "active-class": "active",
                onClick: _ctx.closeMenu
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("九岭绿茶")
                ])),
                _: 1,
                __: [12]
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                to: "/story",
                class: "nav-link",
                "active-class": "active",
                onClick: _ctx.closeMenu
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode("品牌故事")
                ])),
                _: 1,
                __: [13]
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                to: "/team",
                class: "nav-link",
                "active-class": "active",
                onClick: _ctx.closeMenu
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode("管理团队")
                ])),
                _: 1,
                __: [14]
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                to: "/funding",
                class: "nav-link",
                "active-class": "active",
                onClick: _ctx.closeMenu
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("融资计划")
                ])),
                _: 1,
                __: [15]
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                to: "/tbook",
                class: "nav-link",
                "active-class": "active",
                onClick: _ctx.closeMenu
              }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode("留言板")
                ])),
                _: 1,
                __: [16]
              }, 8, ["onClick"]),
              (_ctx.isAuthenticated)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/notes",
                    class: "nav-link",
                    "active-class": "active",
                    onClick: _ctx.closeMenu
                  }, {
                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                      _createTextVNode("笔记本")
                    ])),
                    _: 1,
                    __: [17]
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _cache[19] || (_cache[19] = _createElementVNode("a", {
                href: "http://shop.wanlvjiapin.com/",
                target: "_blank",
                class: "nav-link"
              }, "桃香绿品", -1)),
              (!_ctx.isAuthenticated)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: "/auth",
                    class: "nav-link",
                    "active-class": "active",
                    onClick: _ctx.closeMenu
                  }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode("登录/注册")
                    ])),
                    _: 1,
                    __: [18]
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isAuthenticated)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", {
                        class: "username",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToProfile && _ctx.goToProfile(...args))),
                        title: "点击进入个人设置"
                      }, _toDisplayString(_ctx.currentUser?.username), 1),
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
                        class: "logout-btn"
                      }, "登出")
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            (_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("span", {
                    class: "username",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goToProfile && _ctx.goToProfile(...args))),
                    title: "点击进入个人设置"
                  }, _toDisplayString(_ctx.currentUser?.username), 1),
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
                    class: "logout-btn"
                  }, "登出")
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "music-control fixed",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleMusic && _ctx.toggleMusic(...args))),
          title: "点击播放/暂停背景音乐"
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["music-icon", { 'playing': _ctx.isPlaying }])
          }, "🎵", 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["main-content", { 'full-height': _ctx.$route.path === '/' }])
    }, [
      _createVNode(_component_router_view)
    ], 2),
    _createVNode(_component_ScrollToTop),
    (_ctx.$route.path !== '/'
     && _ctx.$route.path !== '/invite'
     && _ctx.$route.path !== '/game'
     && _ctx.$route.path !== '/view'
   

)
      ? (_openBlock(), _createBlock(_component_AppFooter, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}